import { upsertFieldCapacityOverride } from '@dispatch/shared/services';
import { FieldCapacityOverridePost } from '@dispatch/shared/types';
import { useQueryClient } from 'react-query';
import { useMutate } from '../api/useMutate';

export const useUpsertFieldCapacityOverride = (
  resourceId: string,
  responseFn: (data: {
    success: boolean;
    message?: string;
  }) => void | Promise<unknown>
) => {
  const queryClient = useQueryClient();
  const { mutate, error, status } = useMutate(
    ['upsert-field-capacity-override', resourceId],
    (data: FieldCapacityOverridePost) =>
      upsertFieldCapacityOverride(resourceId, data),
    (data) => {
      queryClient.invalidateQueries([
        'get-resource-field-capacity-overrides',
        resourceId,
      ]);
      responseFn(data as { success: boolean; message?: string });
    }
  );

  return {
    upsertFieldCapacityOverride: mutate,
    upsertFieldCapacityOverrideError: error,
    upsertFieldCapacityOverrideStatus: status,
  };
};
